import { render, staticRenderFns } from "./SizeTable.vue?vue&type=template&id=63525c3c&scoped=true&"
import script from "./SizeTable.vue?vue&type=script&lang=js&"
export * from "./SizeTable.vue?vue&type=script&lang=js&"
import style0 from "./SizeTable.vue?vue&type=style&index=0&id=63525c3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63525c3c",
  null
  
)

export default component.exports